export enum HasPassword {
	FALSE = "FALSE",
	ACTIVE = "ACTIVE",
	BLOCKED = "BLOCKED",
}
